<template>
    <section>
        <el-table
            :data="partners"
            style="width: 100%"
            max-height="400"
            min-height="400"
            v-loading="listLoading"
            fit
            ref="filterTable"
            row-key="name"
            border
            default-expand-all>
            <el-table-column
                prop="name"
                label="Partners"
                min-width="200">
            </el-table-column>
            <el-table-column
                prop="total_daily"
                label="Dispatched Today"
                align="center"
                min-width="200">
            </el-table-column>
            <el-table-column
                prop="total_month"
                label="Monthly Total"
                align="center"
                min-width="200">
            </el-table-column>
            <el-table-column
                fixed="right"
                label=""
                width="100">
                <template slot-scope="scope">
                    <el-button type="success" @click="assign(scope.row.id)" round size="small">Assign</el-button>
                </template>
            </el-table-column>
        </el-table>
    </section>
</template>

<script>
export default {
    name: 'PartnersAssign',
    components: {},
    props: {
        leads: {
            type: Array
        },
        action: {
            required: true
        }
    },
    data() {
        return {
            partners: [],
            listLoading: true
        }
    },
    computed: {},
    watch: {},
    mounted() {
        this.getPartners();
    },
    updated() {
    },
    activated() {
    },
    methods: {
        getPartners() {
            this.$tenant
                .post(`/api/lead-management/partners`, {team: _.get(window.TenantGlobals, 'currentTeamId', null)})
                .then((res) => {
                    this.$set(this.$data, "partners", res.data)
                    this.listLoading = false;
                })
        },
        assign(id) {
            this.action.partner = id;
            this.$emit('assign', true);
        }
    }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
